import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';
import React, { FC, useState, useEffect, useContext } from 'react'
import Modal from 'react-modal';
import { Toast } from 'react-bootstrap';
import EventsService from '../../../services/EventsService';
import { EventModal } from './EventModal';
import ReactQuill from 'react-quill';
import { Context } from '../../..';
import { useNavigate } from 'react-router-dom';
import { ModalPopover } from './modal-popover';
import { modules, formats } from './QuillSettings';
import { MyDocsModal } from './MyDocsModal';

const Event: FC<any> = observer(({ event, setEventModal, setEventData, setEventDate, setDelEventId, setDelEventModal }) => {

    const date = event['create_date'].split('T');
    const formattedDate = date[0].split('-');

    return (
        <div className='row'>
            <div className="col">
                <div className="card mt-2 border-success event" onClick={() => {
                    setEventModal(true);
                    setEventData(event);
                    setEventDate(`${formattedDate[2]}.${formattedDate[1]}.${formattedDate[0]}`);
                }}>
                    <div className="card-header event-header">
                        <h5>

                            {event['header']}
                        </h5>
                    </div>
                </div>
            </div>

            <div className="col-md-1">
                <i className='icon trash' onClick={() => {
                    setDelEventId(event['id']);
                    setDelEventModal(true);
                }} />
            </div>
        </div>

    )
});

interface EventsProps {
    fix: boolean;
    setFix: (value: boolean) => void;
}

const Events: FC<EventsProps> = observer(({ fix, setFix }) => {
    const { store } = useContext(Context);
    const [events, setEvents] = useState<[]>([]);
    const [eventModal, setEventModal] = useState<boolean>(false);
    const [eventData, setEventData] = useState<any>({});
    const [eventDate, setEventDate] = useState<string>('');
    const [delEventId, setDelEventId] = useState<number>(-1);
    const [delEventModal, setDelEventModal] = useState<boolean>(false);

    const getEvents = async () => {
        const events = await EventsService.getSpecEvents();
        setEvents(events.data.results);
    };

    useEffect(() => {
        getEvents();
        setFix(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fix])

    const getItems = () => events.sort((a, b) => b['id'] - a['id']).map((event, i) => {
        return <Event key={i} {...{ event, setEventModal, setEventData, setEventDate, setDelEventId, setDelEventModal }} />
    });

    const deleteEvent = async () => {
        await EventsService.removeEvent(delEventId);
        setFix(true);
        setDelEventModal(false);
        setDelEventId(-1);
    };


    return (
        <div>
            {getItems()}
            <EventModal toggle={eventModal} setToggle={setEventModal} data={eventData} date={eventDate} />
            <ModalPopover
                toggle={delEventModal}
                setToggle={setDelEventModal}
                title={store.lang === 'ba' ? 'Ваҡиғаны алып ташлау' : store.lang === 'ru' ? 'Удаление события' : 'Deleting an event'}
                modalContent={<Trans>Do you want to delete an event?</Trans>}
                clickedButtonOne={() => deleteEvent()}
                clickedButtonTwo={() => { setDelEventModal(false); setDelEventId(-1); }}
                ButtonOneValue={store.lang === 'ba' ? 'Эйе' : store.lang === 'ru' ? 'Да' : 'Yes'}
                ButtonTwoValue={store.lang === 'ba' ? 'Кире ҡайтарыу' : store.lang === 'ru' ? 'Отмена' : 'Cancel'}
            />
        </div>
    )
});

interface ModalProps {
    toggle: boolean;
    setToggle: (value: boolean) => void;
}

export const EventSettingsModal: FC<ModalProps> = props => {
    const { toggle, setToggle } = props;
    const { store } = useContext(Context);
    const navigate = useNavigate();
    const [eventData, setEventData] = useState({ "author": "", "header": "", "text": "", "image1": "", "image2": "", "image3": "", "image4": "", "image5": "", "image6": "", "image7": "", "image8": "", "image9": "", });
    const [fix, setFix] = useState<boolean>(false);
    const [myDocsModal, setMyDocsModal] = useState<boolean>(false);
    const [text, setText] = useState('');
    const [showToast, setShowToast] = useState(false);
    const [toastInfo, setToastInfo] = useState('');

    const onRequestClose = () => {
        setToggle(false);
    };

    const onChange = (e: React.ChangeEvent<any>) => {
        setEventData({ ...eventData, [e.target.id]: e.target.value });
    };

    const saveEvent = async () => {
        if (eventData.image1.replaceAll(' ', '') !== '') {
            await EventsService.createEvent(eventData);
            setFix(true);
            setEventData({ "author": "", "header": "", "text": "", "image1": "", "image2": "", "image3": "", "image4": "", "image5": "", "image6": "", "image7": "", "image8": "", "image9": "", });
            setToastInfo(store.lang === 'ba' ? 'Ваҡиға өҫтәлде' : store.lang === 'ru' ? 'Событие создано' : 'Event has been created');
            setShowToast(true);
        } else {
            alert(store.lang === 'Миниатюраға һылтанманы ҡуйығыҙ' ? 'Эйе' : store.lang === 'ru' ? 'Вставьте ссылку миниатюры' : 'Insert the link of the thumbnail')
        }
    };

    useEffect(() => {
        setEventData({ ...eventData, 'text': text });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [text]);

    useEffect(() => {
        if (!store.user.is_staff) {
            navigate('/');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [store.user.is_staff])


    return (
        <Modal isOpen={toggle} onRequestClose={onRequestClose} ariaHideApp={false} className='Modal'>
            <div className="row Modal__Head d-flex">
                <div className="col">
                    <button type='button' className='btn btn-success' onClick={() => setToggle(false)}>
                        <i className="icon close" />
                        <Trans>Close</Trans>
                    </button>
                    <button type='button' className='btn btn-success ms-3' onClick={() => setMyDocsModal(!myDocsModal)}>
                        <Trans>My files</Trans>
                    </button>
                </div>
                <div className="col text-end"><Trans>Configure the event page</Trans></div>
            </div>
            <form className="Modal__Body">
                <div className="row form-group">
                    <div className="col-md-7">
                        <div className="row mb-3">
                            <label htmlFor="author" className="col-sm-3 col-form-label"><Trans>Author</Trans></label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" id="author" onChange={(e) => onChange(e)} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="header" className="col-sm-3 col-form-label"><Trans>Header</Trans></label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" id="header" onChange={(e) => onChange(e)} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="text" className="col-sm-3 col-form-label"><Trans>Text</Trans></label>
                            <div className="col-sm-9">
                                {/* <textarea rows={10} className="form-control" id="text" onChange={(e) => onChange(e)} /> */}
                                <ReactQuill
                                    className="EventSettingsQuill"
                                    theme="snow"
                                    modules={modules}
                                    formats={formats}
                                    id="text"
                                    onChange={setText} />
                            </div>
                        </div>

                        <div className="row mb-3">
                            <label htmlFor="image1" className="col-sm-3 col-form-label"><Trans>Link of the thumbnail</Trans></label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" id="image1" onChange={(e) => onChange(e)} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="image2" className="col-sm-3 col-form-label"><Trans>Link of the 1st photo</Trans></label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" id="image2" onChange={(e) => onChange(e)} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="image3" className="col-sm-3 col-form-label"><Trans>Link of the 2nd photo</Trans></label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" id="image3" onChange={(e) => onChange(e)} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="image4" className="col-sm-3 col-form-label"><Trans>Link of the 3rd photo</Trans></label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" id="image4" onChange={(e) => onChange(e)} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="image5" className="col-sm-3 col-form-label"><Trans>Link of the 4th photo</Trans></label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" id="image5" onChange={(e) => onChange(e)} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="image6" className="col-sm-3 col-form-label"><Trans>Link of the 5th photo</Trans></label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" id="image6" onChange={(e) => onChange(e)} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="image7" className="col-sm-3 col-form-label"><Trans>Link of the 6th photo</Trans></label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" id="image7" onChange={(e) => onChange(e)} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="image8" className="col-sm-3 col-form-label"><Trans>Link of the 7th photo</Trans></label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" id="image8" onChange={(e) => onChange(e)} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="image9" className="col-sm-3 col-form-label"><Trans>Link of the 8th photo</Trans></label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" id="image9" onChange={(e) => onChange(e)} />
                            </div>
                        </div>

                        <button type="button" className="btn btn-success" onClick={() => saveEvent()}><Trans>Save</Trans></button>
                    </div>
                    <div className="col-md-5">
                        <Events {...{ fix, setFix }} />
                    </div>
                </div>
            </form>
            <Toast className='toast p-0 border-success' bg='light' onClose={() => setShowToast(false)} show={showToast} delay={5000} autohide>
                <Toast.Header className='bg-success m-0 text-light'>
                    <strong className="me-auto"><Trans>Information</Trans></strong>
                </Toast.Header>
                <Toast.Body><strong>{toastInfo}</strong></Toast.Body>
            </Toast>
            <MyDocsModal toggle={myDocsModal} setToggle={setMyDocsModal} />
        </Modal>
    );
};